import React from 'react';
import { useStyles } from './HomePage.styles';
import ParticleBackground from './ParticleBackground';

function Jumbotron({ isAuthenticated, onLogin }) {
  const classes = useStyles();

  return (
    <div className={classes.jumbotron}>
      <ParticleBackground />
      <div className={classes.jumbotronContent}>
        <h1 className={classes.jumbotronTitle}>LEGO</h1>
        <h2 className={classes.jumbotronSubtitle}>
          Advance everyone with ace agility & quality in model, code & data CI/CD
        </h2>
        <p className={classes.jumbotronLead}>
          Proudly empowered by STCA WebXT Platform LEGO Team
        </p>
        {isAuthenticated ? (
          <a
            href="https://eng.ms/docs/microsoft-ai/webxt/bing-fundamentals/lego/lego-onboarding-guides"
            target="_blank"
            rel="noopener noreferrer"
            className={classes.getStartedButton}
          >
            Get Started →
          </a>
        ) : (
          <button
            onClick={onLogin}
            className={classes.getStartedButton}
          >
            Login to Continue
          </button>
        )}
      </div>
    </div>
  );
}

export default Jumbotron;